import { render } from "./ClientCheckout.vue?vue&type=template&id=2c415304&scoped=true"
import script from "./ClientCheckout.vue?vue&type=script&lang=js"
export * from "./ClientCheckout.vue?vue&type=script&lang=js"

import "./ClientCheckout.vue?vue&type=style&index=0&id=2c415304&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c415304"]])

export default __exports__